/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Editor_Copy_TokenInputs */

const fr_settings_editor_copy_token = /** @type {(inputs: Settings_Editor_Copy_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier mon jeton`)
};

const en_settings_editor_copy_token = /** @type {(inputs: Settings_Editor_Copy_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy my token`)
};

/**
* | output |
* | --- |
* | "Copy my token" |
*
* @param {Settings_Editor_Copy_TokenInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_editor_copy_token = /** @type {((inputs?: Settings_Editor_Copy_TokenInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Editor_Copy_TokenInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_editor_copy_token(inputs)
	return en_settings_editor_copy_token(inputs)
});